/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import "./HousekeepingContent2.css";

/* ==== IMAGES (use real icons here) ==== */
import IconTrusted from "../../Image/HouseKeeping/Housekeeping1.png";
import IconCoverage from "../../Image/HouseKeeping/Housekeeping1.png";
import IconCompliance from "../../Image/HouseKeeping/Housekeeping1.png";


const ManpowerContent = () => {
  return (
    <div>
    <section className="hk2-wrapper">

      {/* TAG */}
      <div className="hk2-tag">About This Service</div>

      {/* TITLE */}
      <h2 className="hk2-title">Manpower & Staffing Solutions</h2>
      <div className="hk2-underline"></div>

      {/* CONTENT BOX */}
      <div className="hk2-box">
        <p>
           We provide comprehensive manpower staffing solutions across all facility management functions. Our diverse talent pool includes skilled, semi-skilled, and unskilled personnel, all fully police verified and compliant with statutory requirements.
        </p>

        <p>
       From housekeeping staff to facility managers, technical personnel to administrative support, we supply the right talent to keep your operations running smoothly. All personnel undergo thorough background verification, comprehensive training, and are managed with complete ESI, PF, and labour law compliance.
        </p>

        <p>
Our staffing solutions offer flexibility, scalability, and complete workforce management including payroll, supervision, and performance monitoring to meet your dynamic business requirements.
        </p>
      </div>

      {/* ICON 3 CARDS (IMAGE LEFT, TEXT RIGHT) */}
      <div className="hk2-icons">

        <div className="hk2-card">
          <div className="hk2-left">
            <div className="hk2-icon-wrap">
              <img src={IconTrusted} className="hk2-icon-img" alt="Trusted Service" />
            </div>
          </div>
          <div className="hk2-right">
            <h4>Trusted Service</h4>
            <p>Since 2019</p>
          </div>
        </div>

        <div className="hk2-card">
          <div className="hk2-left">
            <div className="hk2-icon-wrap">
              <img src={IconCoverage} className="hk2-icon-img" alt="Coverage" />
            </div>
          </div>
          <div className="hk2-right">
            <h4>Coverage</h4>
            <p>15 Cities</p>
          </div>
        </div>

        <div className="hk2-card">
          <div className="hk2-left">
            <div className="hk2-icon-wrap">
              <img src={IconCompliance} className="hk2-icon-img" alt="Compliance" />
            </div>
          </div>
          <div className="hk2-right">
            <h4>Compliance</h4>
            <p>100% Certified</p>
          </div>
        </div>

      </div>

    </section>
   
    </div>
  );
};

export default ManpowerContent;
